import React, { Component} from 'react'
import { Link } from 'react-router-dom'

class ApplyInfo extends Component
{
  render() {
    return(
      <React.Fragment>
        <main>
          <div className="content"  >
            <div className="section-info">

                <section className="section-intro-copy">
                  <div className="intro-copy-block">
                    <div className="copy">
                    
                      <h4>전자문서지갑 서비스안내</h4>
                      <p className="copy-word2"> 
                        산업통상자원부 전자문서지갑은 전자무역 및 관련 비즈니스에서 <br />
                        발급하는 전통적인 서면 증명서를 디지털 증명서로 발급 유통할 수 <br />
                        있도록 제공하는 기업의 디지털 사서함 서비스 입니다.
                      </p>
                    </div>
                    <div className="obj">
                        <img src="./images/info_img01.png" alt=" " />
                    </div>

                  </div>
                </section>

                <section className="section-info-copy">                
                  <div className="intro-copy-block card-info">
                    <div className="copy">                   
                      <p className="copy-word">[제출기업] 증명서 발급 및 제출<br />
                        <strong>오프라인 발급과 제출 불편하셨죠?</strong>
                      </p>
                      <p className="copy-txt">
                        실시간으로 발급된 전자증명서를 즉시 제출할 수 있습니다. <br />
                        증명서 발급 및 제출을 위해 소요되는 시간과 비용이 절감됩니다.
                      </p>
                    </div>
                    <div className="obj">
                        <img src="./images/info_img02.png" alt=" " />
                    </div>
                  </div>
                </section>

                <section className="section-info-copy right">                
                  <div className="intro-copy-block card-info">
                    <div className="copy">                   
                      <p className="copy-word">[수취기관] 증명서 수취 및 검증<br />
                        <strong>오프라인 수취와 진위확인 불편하셨죠 ?</strong>
                      </p>
                      <p className="copy-txt">
                        인터넷 민원창구 운영에도 불구하고 증명서는 오프라인으로 수신 받으셨죠?<br />
                        전자증명서 수취 즉시 타임스탬프 및 블록체인 기술로 위변조 여부를 확인할 수 있습니다.
                      </p>
                    </div>
                    <div className="obj">
                        <img src="./images/info_img03.png" alt=" " />
                    </div>
                  </div>
                </section>

                <section className="section-info-copy ">                
                  <div className="intro-copy-block card-info">
                    <div className="copy">                   
                      <p className="copy-word">[발급기관] 발급 증명서 위변조 위험 방지 <br />
                        <strong>증명서의 기술적 위변조 방지 조치 제공 !</strong>
                      </p>
                      <p className="copy-txt">
                        전자무역, 시험성적서, 교정성적서 등 기업 비즈니스에  <br />
                        발급/유통되는 증명서는 계속 확장됩니다.  <br />
                        ※ 증명서 발급 기관은 언제든지 플랫폼에 참여할 수 있습니다.
                      </p>
                    </div>
                    <div className="obj">
                        <img src="./images/info_img03.png" alt=" " />
                    </div>
                  </div>
                </section> 

            </div>                         
          </div>
        </main>

      </React.Fragment>
    )
  }
}

export default ApplyInfo
